import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, WritableSignal, signal } from '@angular/core';

import { AvatarsComponent } from '@libs/ui-lib';
import { Person } from 'libs/ui-lib/src/lib/components/avatar/interfaces';

@Component({
  selector: 'lib-collaboration-participants',
  imports: [CommonModule, AvatarsComponent],
  templateUrl: './collaboration-participants.component.html',
  styleUrl: './collaboration-participants.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CollaborationParticipantsComponent {
  @Output() public openAddParticipantsModal = new EventEmitter<void>();

  readonly #participants: WritableSignal<Person[]> = signal([]);

  @Input() public set participants(participants: Person[]) {
    this.#participants.set(participants.sort(this.sortParticipants));
  }

  public get participants(): Person[] {
    return this.#participants();
  }

  public sortParticipants(a: Person, b: Person): number {
    const nameA = `${a.firstName} ${a.lastName}`.toLowerCase();
    const nameB = `${b.firstName} ${b.lastName}`.toLowerCase();

    return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
  }
}
